import React, { useState} from "react";
import {currencyConverter, generate_token, serverLink} from "../../url";
import axios from "axios";
import {showAlert} from "../../common/sweetalert/sweetalert";
import {connect} from "react-redux";
import Loader from "../../common/loader";
import {toast} from "react-toastify";
import ImageUpload from "../../common/image-upload/image-upload";
function BirthCertificate(props) {
    const { patientSerial, patientName, walletAmount} = props;
    const token = props.loginData[0]?.token;
    const [IsLoading, setIsLoading] = useState(false)
    const [IsFormLoading, setIsFormLoading] = useState(false)
    const [ImagePath, setImagePath] = useState('')
    const [ImageDisplay, setImageDisplay] = useState('')


    const InitialValue = {
        patientSerial: props.patientSerial,
        patientName: props.patientName,
        babyName: props.patientName,
        birthCertificateID: "",
        mother: "",
        father: "",
        dateOfBirth: "",
        timeOfBirth: "",
        placeOfBirth: "",
        weightAtBirth: "",
        certificateFile: "",
        ImagePath: "",
        ImageDisplay: "",
        deliveredBy: "",
        submittedBy: `${props.loginData[0]?.userID}`,
    }
    const [formData, setFormData] = useState(InitialValue)
    const resetFormData = () => {
        setFormData(InitialValue)
    }
    const onEdit = async (e) => {
        setFormData({...formData, [e.target.id]: e.target.value})
    }

    const addCertificate = async () => {
        if (formData.mother.toString().trim() === ''){
            toast.error("Please enter father's name")
            return false
        }
        if (ImagePath === ''){
            toast.error("Please select certificate file")
            return false
        }
        setIsFormLoading(true)
        toast.info("please wait...");
        await axios.get(`${serverLink}patient/birth-certificate/verify/${formData.patientSerial}`)
            .then(async (res) => {
                if (res.data.length > 0){
                    toast.error("Birth certificate has already been uploaded");
                }else{
                    await axios.post(`${serverLink}patient/birth-certificate/upload`, formData, token).then(async (result) => {
                        if (result.data.message === "success") {
                            if (ImagePath !== "") {
                                const formData2 = new FormData();
                                formData2.append('photo', ImagePath);
                                formData2.append('entry_id', result.data.entry_id)
                                axios.patch(`${serverLink}patient/upload-birth-certificate`, formData2)
                                    .then(async (res) => {
                                        toast.success("Birth Certificate Added Successfully");
                                        setIsFormLoading(false);
                                        props.setRebuildBirthCert(generate_token(5));
                                        document.getElementById("closeBirthCertificate").click();
                                        setImagePath('')
                                        setImageDisplay('')
                                        resetFormData()
                                    })
                                    .catch(err => {
                                        setIsFormLoading(false);
                                        showAlert(
                                            "ERROR",
                                            "Something went wrong uploading the image. Please try again!",
                                            "error"
                                        );
                                    });
                            }else{
                                toast.success("Birth Certificate Added Successfully");
                                setIsFormLoading(false);
                                props.setRebuildBirthCert(generate_token(5));
                                document.getElementById("closeBirthCertificate").click();
                                setImagePath('')
                                setImageDisplay('')
                                resetFormData()
                            }
                        } else {
                            setIsFormLoading(false);
                            toast.error("Something went wrong adding certificate. Please try again!");
                        }
                    }) .catch((error) => {
                        showAlert(
                            "NETWORK ERROR",
                            "Please check your connection and try again!",
                            "error"
                        );
                    });
                }
            })
            .catch((err) => {
                console.log("NETWORK ERROR");
            });
    }

    return IsLoading ? <Loader/> : <>
        <div id={`${
            typeof props.id !== "undefined" ? props.id : "responsive-modal"
        }`} className="modal fade bs-example-modal-lg" tabIndex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true" style={{display: 'none'}}>
            <div className="modal-dialog modal-lg">
                <div className="modal-content">
                    <div className="modal-header text-white" style={{backgroundColor: '#4b4949'}}>
                        <h2 className="modal-title" id="myLargeModalLabel">{props.title ?? ""}</h2>
                        <button type="button" className={`${
                            typeof props.close !== "undefined" ? props.close : "closeModal"
                        }`}  id={`${
                            typeof props.close !== "undefined" ? props.close : "close"
                        }`} data-dismiss="modal" aria-hidden="true">×</button>
                    </div>
                    <div className="modal-body">
                        <div className="row">
                            <div className="col-md-4 col-4 b-r"><strong>Baby Name</strong>
                                <br/>
                                <p className="text-muted">{patientName}</p>
                            </div>
                            <div className="col-md-4 col-4 b-r"><strong>Patient ID</strong>
                                <br/>
                                <p className="text-muted">{patientSerial}</p>
                            </div>
                            <div className="col-md-4 col-4 b-r"><strong>Wallet</strong>
                                <br/>
                                <p className="text-muted">{currencyConverter(walletAmount)}</p>
                            </div>
                            <div className="col-md-12"
                                 style={{borderBottom: '2px solid #EEEEEE', marginBottom: '30px'}}></div>

                            <div className="col-md-6 mb-3">
                                <label htmlFor="title">Mother's Name <span className="text-danger">*</span></label>
                                <input
                                    name="mother"
                                    type="text"
                                    className="form-control"
                                    id="mother"
                                    value={formData.mother}
                                    onChange={onEdit}
                                    required
                                />
                            </div>
                            <div className="col-md-6 mb-3">
                                <label htmlFor="title">Father's Name <span className="text-danger">*</span></label>
                                <input
                                    name="father"
                                    type="text"
                                    className="form-control"
                                    id="father"
                                    value={formData.father}
                                    onChange={onEdit}
                                    required
                                />
                            </div>
                            <div className="col-md-6 mb-3">
                                <label htmlFor="title">Date Of Birth <span className="text-danger">*</span></label>
                                <input
                                    name="dateOfBirth"
                                    type="date"
                                    className="form-control"
                                    id="dateOfBirth"
                                    max={new Date().toISOString().split('T')[0]}
                                    value={formData.dateOfBirth}
                                    onChange={onEdit}
                                    required
                                />
                            </div>
                            <div className="col-md-6 mb-3">
                                <label htmlFor="title">Time Of Birth <span className="text-danger">*</span></label>
                                <input
                                    name="timeOfBirth"
                                    type="time"
                                    className="form-control"
                                    id="timeOfBirth"
                                    value={formData.timeOfBirth}
                                    onChange={onEdit}
                                    required
                                />
                            </div>

                            <div className="col-md-6 mb-3">
                                <label htmlFor="title">Place Of Birth <span className="text-danger">*</span></label>
                                <input
                                    name="placeOfBirth"
                                    type="text"
                                    className="form-control"
                                    id="placeOfBirth"
                                    value={formData.placeOfBirth}
                                    onChange={onEdit}
                                    required
                                />
                            </div>
                            <div className="col-md-6 mb-3">
                                <label htmlFor="title">Weight At Birth (in KG)<span className="text-danger">*</span></label>
                                <input
                                    name="weightAtBirth"
                                    type="number"
                                    className="form-control"
                                    id="weightAtBirth"
                                    value={formData.weightAtBirth}
                                    onChange={onEdit}
                                    required
                                />
                            </div>
                            <div className="col-md-12 mb-3">
                                <label htmlFor="title">Delivered By <span className="text-danger">*</span></label>
                                <input
                                    name="deliveredBy"
                                    type="text"
                                    className="form-control"
                                    id="deliveredBy"
                                    value={formData.deliveredBy}
                                    onChange={onEdit}
                                    required
                                />
                            </div>

                            <div className="col-md-12 mb-3">
                                <ImageUpload
                                    maxSize={200}
                                    setImagePath={setImagePath}
                                    setImageDisplay={setImageDisplay}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-default waves-effect" data-dismiss="modal">Close
                        </button>
                        {
                            IsFormLoading ?
                                <button type="button" className="btn btn-primary ms-auto">
                                    <span><span className="spinner-border spinner-border-sm me-2" role="status"/> Please wait...</span>
                                </button>
                                :
                                <button type="button" onClick={addCertificate}
                                        className="btn btn-danger waves-effect waves-light">{props.btn ?? "submit"}</button>
                        }
                    </div>
                </div>
            </div>
        </div>
    </>
}

const mapStateToProps = (state) => {
    return {
        loginData: state.LoginDetails,
    };
};
export default connect(mapStateToProps, null)(BirthCertificate);